module.exports = __webpack_public_path__ + "img/ry-nav-act.2a53c7ed.png";